import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {GpsPermissionType} from "../../../types/gps-permission.type";
import * as _ from "lodash";
import {LocationHolderType} from "../../../../commons/types/locationHolder.type";

require('./agent-location.scss');
@Component({
  standalone: false,
  selector: 'app-agent-location',
  templateUrl: './agent-location.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentLocationComponent implements OnInit, OnChanges {
  @Input() location: any;
  @Input() agentId?: string;
  @Input() lastUpdate: any;
  @Input() showAddress: boolean;
  @Input() showText: any;
  @Input() direction: any;
  @Input() gpsStatus: boolean;
  @Input() gpsPermission: GpsPermissionType;
  @Input() locationTrackingApproval: boolean;


  public loading: boolean;
  public agentLocationAddress: any;
  public status: any;


  constructor(@Inject('latLngToAddress') private latLngToAddress, @Inject('locationService') private locationService) {
  }

  ngOnInit() {
    this.loading = false;
    if (_.isUndefined(this.showAddress)) {
      this.showAddress = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gpsStatus) {
      this.status = _.isUndefined(this.gpsStatus) || _.isNull(this.gpsStatus) ? undefined : (!!this.gpsStatus ? 'on' : 'off');
    }
  }

  getLocation() {
    if (this.location?.latitude && this.location?.longitude) {
      this._setLocationAddress(this.location);
    } else if (this.agentId) {
      this._setAgentLocation();
    }
  }

  private _setAgentLocation() {
    const payload = {
      holderId: this.agentId,
      holder: LocationHolderType.Agent
    }

    this.loading = true;
    this.locationService.getLocations([payload])
      .then((locations: any) => {
        this.lastUpdate = locations[0].updatedAt;
        this._setLocationAddress(locations[0].coordinates);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _setLocationAddress(location) {
    this.loading = true;
    this.latLngToAddress(location.latitude, location.longitude)
      .then((place) => {
        this.agentLocationAddress = {
          lat: location.lat,
          lng: location.lng,
          place: place
        };
      })
      .finally(() => {
        this.loading = false;
      })
  }

}
